import React from "react";
// import BigNumber from "bignumber.js";
import {useStakingContract, useStakingDispatch} from "context/StakingContract";
import {SET_ERROR_WITH_MESSAGE, STAKE_TX_HASH} from "context/StakingContract/actions";
import StakingContract from "context/StakingContract/StakingContract";

const Withdraw = ({goToStep, setSuccess}) => {
  const {stakingContract} = useStakingContract();
  const dispatch = useStakingDispatch();

  const [withdrawDate, setInitWithdrawDate] = React.useState('0');

  React.useEffect(()=>{
    if (StakingContract.hasMetamask()) {
      stakingContract.getStakeDeposit()
        .then(res => {
          setInitWithdrawDate(res[2].toString());
      }).catch(err => {
        console.warn("error get stake deposit", err);
      });
    }
  }, [stakingContract]);


  const initiateWithdraw = () => {
    stakingContract.initiateWithdrawal()
      .then(v => {
        console.log("withdraw initiated", v);
        dispatch({type: STAKE_TX_HASH, payload: v.hash});
        goToStep(3);
      })
      .catch(e => {
        dispatch({type: SET_ERROR_WITH_MESSAGE, payload: ""});
        goToStep(3);
      // alert("error encountered, check console");
        console.warn(e);
      });
  };

  const withdraw = () => {
    stakingContract.executeWithdrawal()
      .then(v => {
        console.log("withdraw initiated");
        dispatch({type: STAKE_TX_HASH, payload: v.hash});
        goToStep(3);
      })
      .catch(e => {
        dispatch({type: SET_ERROR_WITH_MESSAGE, payload: ""});
        goToStep(3);
        console.warn(e);
      });
  };

  const pauseRewards = () => {
    stakingContract.toggleRewards(false)
      .then(v => alert("rewards should be now paused"))
      .catch(e => alert("Not able to pause rewards - either you are not the owner or rewards already paused"));
  };

  const unpauseRewards = () => {
    stakingContract.toggleRewards(true)
      .then(v => alert("rewards should be now un-paused"))
      .catch(e => alert("Not able to un-pause rewards - either you are not the owner or rewards already un-paused"));
  };

  const pauseContract = () => {
    stakingContract.togglePaused(false)
      .then(v => alert("contract should be now paused"))
      .catch(e => alert("Not able to pause contract - either you are not the owner or contract already paused"));
  };

  const unpauseContract = () => {
    stakingContract.togglePaused(true)
      .then(v => alert("contract should be now un-paused"))
      .catch(e => alert("Not able to un-pause contract - either you are not the owner or contract already un-paused"));
  };

  return (
    <div className="card">
      <div className="card-body">
        {
          withdrawDate === '0' ? 
          <>
            <h3>Initialize Withdrawal</h3>
            <p className="lead">
              1<sup>st</sup> of 2 transactions needed to withdraw
            </p>
            <p>
              The withdrawal process has two steps. On the first transaction the withdrawal is initialized, and after 7 days passed a second withdrawal confirmation is required to finalize the process.
            </p>
            <p className="mb-4">
              You will now be asked to confirm the withdrawal initialization by sending a Metamask transaction.
            </p>
            <button className="btn btn-primary" onClick={initiateWithdraw}>Initialize Withdraw</button>
          </> :
          <>
            <h3>Finalize Withdrawal</h3>
            <p className="lead">
              2<sup>nd</sup> of 2 transactions needed to withdraw
            </p>
            <p>
              You will now be asked to confirm the withdrawal finalization by sending a Metamask transaction.
            </p>
            <p className="mb-4">
            After the transaction is processed your stake as well as the stake reward will be transferred back to your wallet.
            </p>
            <button className="btn btn-primary" onClick={withdraw}>Withdraw</button>
          </>
        }
      </div>
    </div>
  );
};

export default Withdraw;